
	import { RoutineMeasurement } from "@/domain/entities/EntityFields";
	import { pprint } from "@/helpers/pprint";
	import useDoctor from "@/store/DoctorState";
	import { defineComponent, ref } from "vue";

	export default defineComponent({
		setup() {
			const DEFAULT_VALUE_TIME = "00";
			let schedules = ref<RoutineMeasurement[]>([{ takeMeasureTime: "00:00" }]);
			const measurementForm = ref(null);
			const cleanSelects = () => {
				(measurementForm.value! as HTMLElement)
					.querySelectorAll("select")
					.forEach((s) => (s.value = DEFAULT_VALUE_TIME));
				schedules.value.length = 1
			};
			const { updateMeasurementSchedule } = useDoctor();
			const formatTimeValue = (t: string | number): string => {
				if (typeof t == "number") t = t.toString();
				return t.padStart(2, "0");
			};
			const addRoutine = () => {
				schedules.value.push({ takeMeasureTime: "00:00" });
			};
			const removeRoutine = (i: number) => {
				schedules.value.splice(i, 1);
			};
			const onHourInput = (ev: Event, mr: RoutineMeasurement) => {
				pprint("ev", ev);
				let value = (ev.target as HTMLInputElement).value;
				mr.takeMeasureTime = mr.takeMeasureTime.replace(/^(\d{2})/, value);
			};
			const onMinuteInput = (ev: Event, mr: RoutineMeasurement) => {
				pprint("ev", ev);
				let value = (ev.target as HTMLInputElement).value;
				mr.takeMeasureTime = mr.takeMeasureTime.replace(/(\d{2})$/, value);
			};
			const submitUpdate = async () => {
				pprint("schedules", schedules.value);
				try {
					await updateMeasurementSchedule(schedules.value);
					cleanSelects();
				} catch (err) {
					console.error(err);
				}
			};

			return {
				schedules,
				addRoutine,
				removeRoutine,
				submitUpdate,
				onMinuteInput,
				onHourInput,
				formatTimeValue,
				measurementForm,
			};
		},
	});
